$(document).ready(function(){

  
  $('.accordion-header_tag').click(function(){
    $('.accordion-item_tag .accordion-content_tag').slideToggle(300);
})
  
  $(document).on('click','.filter-col .option',function (){
    $(this).toggleClass("icon-add-svg")
  });
  $(document).on('click','.footer-button-xs .filter-plus',function (){
    $(".main-collection-section .cc-product-filter").toggleClass("-in");
    return false;
  });
  $('body').click(function(e){
    var menu_contain = $(".main-collection-section .cc-product-filter");
    if (!menu_contain.is(e.target) && menu_contain.has(e.target).length === 0)
    {
      $('.main-collection-section .cc-product-filter').removeClass("-in");
    }
  });

  
  $(".template-suffix-collaborations .add_to_crt_btn button").click(function(e){
    e.preventDefault
    if($('.product_text input[type="checkbox"]').prop('checked')) {
       var variantID = $(".product_text input[type='checkbox']").attr("data_value");
       var variantQty =  1;
        if ($('[value="' + variantID + '"]').length < 1) {
          console.log("Adding variant to cart...");
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: variantID,
              quantity: variantQty
            },
            async: false,
            success: function(){
              console.log('sucess')
              checkNopenCart()
            },
            error:function(XML,result){
              console.log(XML+'sucess'+result)
            }
          });
        } else {
          console.log("Variant is already in cart.");
        }
      }else{
        console.log("false.");
      } 
  });
  $(".add_to_crt_btn button").click(function(e){  
    e.preventDefault(); 
    e.stopPropagation();
    console.log('add_to_crt_btn click');

    var text = $('.product_check_box input:checked').val();
    if(text == 'yes'){
      //Ajax request to add special item to cart
      // var text_input = $(".wc_custom_input").val();
      var $input = $(".wc_custom_input");
      var text_input = $input.hasClass("embossing_3letter_2digits")
        ? $input.val().toUpperCase()
        : $input.val();

      var color_text = $('.wc_embroidery_work .text_color input:checked').val();
      var qty = $('#emb_qty').attr('data-embqty');
      var id = $('#emb_qty').attr('data-id');
      var name = $('#emb_qty').attr('data-title');
      var custom_text = $('#emb_qty').attr('data-custom-text');
      console.log('custom_text', custom_text)
      console.log('color_text', color_text)
      
      console.log(text_input)
      if (text_input === '') {
        $('.error').show();
        return false;
      } else {
        console.log(text_input)
        $('.error').hide();
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: 'json',
          data: {
            quantity: qty,
            id: id,
            properties: {
              [custom_text] : text_input,
              'Custom Embroidery Text Color': color_text,
              'Product Name':name
            }
          },
          async: false,
          success: function(){
          console.log('sucess')
            checkNopenCart()
          },
          error:function(XML,result){
          console.log(XML+'sucess'+result)
          }
        });
        //Ajax Request to add current product page to cart
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: $('form[action="/cart/add"]').serialize(),
          async: false,
          success: function(){
           // location.href= "/cart";
            jQuery.getJSON('/cart.js', function(cart) {
            jQuery(".cart_counts").html('(' + cart.item_count + ')');
              setTimeout(function(){
               $('.cart-count').html(cart.item_count); 
              },500)
               
            });
  
            var tem =  $(".wc_custom_input").val();
            console.log(tem)
           checkNopenCart()
          }
        });
        
      }
    }else{
      var texts = $(".add_to_crt_btn").attr('data-value');
      console.log('add_to_crt_btn else clicked');
      console.log(texts);

      var formData = $('form[action="/cart/add"]').serializeArray();

      formData.push({
        name: 'id',
        value: texts
      });

      formData.push({
        name: 'quantity',
        value: 1
      });

      jQuery.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: $.param(formData),
        async: false,
        success: function(){
          console.log('success work');
          jQuery.getJSON('/cart.js', function(cart) {
            console.log(cart);
            jQuery("span.cart_counts").html('(' + cart.item_count + ')');
            $('.cart-count').html(cart.item_count);
          });
          checkNopenCart();
        }
      });

      // old
      // var texts = $(".add_to_crt_btn").attr('data-value')
      // console.log('add_to_crt_btn else clicked');
      // console.log(texts)
      // jQuery.ajax({
      //   type: "POST",
      //   url: '/cart/add.js',
      //   data: {
      //     quantity: 1,
      //     id: texts,
      //   },
      //   async: false,
      //   success: function(){
      //     console.log('success work');
      //     jQuery.getJSON('/cart.js', function(cart) {
      //       console.log(cart);
      //       jQuery("span.cart_counts").html('(' + cart.item_count + ')');
      //       $('.cart-count').html(cart.item_count);
      //     });
      //     checkNopenCart()
      //   }
      // })

      // old old
      // jQuery.ajax({
      //   type: "POST",
      //   url: '/cart/add.js',
      //   data: $('form[action="/cart/add"]').serialize(),
      //   async: false,
      //   success: function(){
      //     console.log('success work');
      //     jQuery.getJSON('/cart.js', function(cart) {
      //       console.log(cart);
      //       jQuery("span.cart_counts").html('(' + cart.item_count + ')');
      //       $('.cart-count').html(cart.item_count);
      //     });
      //     checkNopenCart()
      //   }
      // })
    }
  })

  $(".qu_button").on("click" , function(){
    setTimeout (function(){
      var text = $(".quantity-wrapper input").val();
      $(".custon_quen").val(text);
    }, 200);
  });
  
//   var HHeight = $('.site-control').outerHeight();
//   $('#page-content').css({'padding-top':HHeight});

//   $('.text-slider').slick({
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll:1,
//       arrows: true,
//       cssEase: 'linear',
    
//   });

  
  var $slider = $('.text-slider');

if ($slider.length) {
  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement('div');
  sliderCounter.classList.add('slider__counter');
  
  
  var updateSliderCounter = function(slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
    $(sliderCounter).text(currentSlide + '/' + slidesCount)
  };

  $slider.on('init', function(event, slick) {
    $slider.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider.on('afterChange', function(event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });

  $slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
  });
}
  

  $(".accd_div").hide();
  $(".product_accodian_data.active .accd_div").show();
  $(".product_accodian_data h3").click(function(){
       $(this).next(".accd_div").slideToggle();
    $(this).parent().toggleClass("active").siblings().removeClass("active")
    $(this).parent().siblings().find(".accd_div").slideUp();

  })
  

  $('.wc_custom_addtocart_btn').click(function(e){
    e.preventDefault();
    var item_id = $(this).parent().find('[name="id"]').val();
    var text = $(this).closest('.wc_custom_product').find('.wc_custom_prd_details .wc_custom_note .wc_custom_input').val();
    $('[data-custom-add-to-cart-text]').addClass('hide');
    $('[data-custom-loader]').removeClass('hide');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: item_id,
        properties: {
          'Custom Embroidery Text': text
        }
      },
      dataType: 'json', 
      success: function (data) { 
        var count = parseInt($('[data-cart-count]').text());
        count = count + data.quantity;
        $('[data-cart-count]').text(count);
        $('[data-custom-loader]').addClass('hide')
        $('[data-custom-add-to-cart-text]').removeClass('hide');
        $('[data-custom-add-to-cart-text]').text('Added');
        checkNopenCart();
      } 
    });
  });
  
  
  /*$("#contact_number").on("blur", function(){
    
    var mobNum = $(this).val();
    var filter = /^\d*(?:\.\d{1,2})?$/;
    
    if (filter.test(mobNum)) {
      if(mobNum.length==10){
        $('#folio-invalid').html();
      } else {
        console.log('Please put 10  digit mobile number');
        $("#folio-invalid").removeClass("hidden");
        $('#folio-invalid').html('Please put 10  digit mobile number');
        return false;
      }
    } else {
      console.log('Not a valid number');
      $("#folio-invalid").removeClass("hidden");
      $('#folio-invalid').html('Not a valid number');
      return false;
    }
    
  });*/

  // $(window).scroll(function() {
  //   $('body').addClass('body_scroll')
  // });

  var f_val = $('.luggage_tag_variants .text_color label input:checked').val()
  // console.log("f_val-----",f_val);
  
  $('.luggage_tag_variants .selected_text span p.name').html(f_val)

  var f_val_next = $('.wc_custom_prd_details .text_color label input:checked').val()
  // console.log("f_val_next-----",f_val_next);
  $('.wc_custom_prd_details .selected_text span p.name').html(f_val_next)

  $('.wc_custom_product').hide();
  $(document).on('click','.text_color label',function(e){
    $(this).addClass('active').siblings().removeClass('active')
  });
  
  $(document).on('click','.luggage_tag_variants .text_color label',function(e){
    var val = $(this).find('input').val();
    $('.luggage_tag_variants .selected_text span p.name').html(val)
  });
  $(document).on('click','.wc_custom_product .text_color label',function(e){
    var val = $(this).find('input').val();
    $('.wc_custom_product .selected_text span p.name').html(val)
  });

  $('.product_check_box input').click(function() {
    var val = $(this).val();
    var data_price = $(this).data('price');
    if (val == "yes") {
      $('.wc_custom_product').slideToggle();
      // console.log("updated---",data_price);
      $('.add_to_crt_btn .button .button-money-control').text(data_price);
    } else {
      $('.wc_custom_product').slideToggle();
      $('.add_to_crt_btn .button .button-money-control').text(data_price);
    }
  });

    $('.csm_embossing_status .tag_check input').click(function() {
    var val = $(this).val();
      // console.log("valllll-----",val)
      var data_price = $(this).data('price');
    if (val == "yes") {
      $('.tag_product_wrap .recipient-form-wrapper').show();
      $('.add_to_crt_btn .button .button-money-control').text(data_price);
    } else {
      $('.tag_product_wrap .recipient-form-wrapper').hide();
      $('.add_to_crt_btn .button .button-money-control').text(data_price);
    }
  });

// Gift voucher product vairant select update button text price code----------------------------
  
// $(document).ready(function () {
//   document.querySelectorAll('.selector-wrapper .clickyboxes li a').forEach(anchor => {
//     // console.log("anchor---",anchor);
//     anchor.addEventListener('click', function () {
//       const value = this.getAttribute('data-value'); // e.g. "$150.00"
//       // console.log("data-value:", value);

//       const button = document.querySelector('.product-detail__form__action .button');

//       if (value && button) {
//         // Update data attribute
//         button.setAttribute('data-price', value);

//         // Extract existing label without price
//         const originalText = button.textContent.trim();
//         const updatedText = originalText.replace(/\$[\d,.]+/, value);

//         button.textContent = updatedText;

//         // console.log("Updated button text:", updatedText);
//       }
//     });
//   });
// });


// $(document).ready(function () {
//   document.querySelectorAll('.selector-wrapper .clickyboxes li a').forEach(anchor => {
//     anchor.addEventListener('click', function () {
//       const button = document.querySelector('.product-detail__form__action .button');
//       const span = button?.querySelector('.button-money-control');

//       if (button && span) {
//         // Small delay so Shopify has time to update .current-price
//         setTimeout(() => {
//           const priceEl = document.querySelector('.current-price.theme-money');
//           if (priceEl) {
//             let priceText = priceEl.textContent.trim();
//             let match = priceText.match(/\$[\d,.]+/);
//             let cleanPrice = match ? match[0] : priceText;

//             button.setAttribute('data-price', cleanPrice);
//             span.textContent = cleanPrice;
//           }
//         }, 50); // 50–100ms is usually enough
//       }
//     });
//   });
// });


$(document).ready(function () {
  document.querySelectorAll('.selector-wrapper .clickyboxes li a').forEach(anchor => {
    anchor.addEventListener('click', function () {
      const button = document.querySelector('.product-detail__form__action .button');
      const span = button?.querySelector('.button-money-control');

      if (button && span) {
        // Small delay so Shopify has time to update .current-price
        setTimeout(() => {
          const priceEl = document.querySelector('.current-price.theme-money');
          if (priceEl) {
            let priceText = priceEl.textContent.trim();

            // Extract numeric part
            let match = priceText.match(/[\d,.]+/);
            let amount = match ? parseFloat(match[0].replace(/,/g, '')) : 0;

            // Update button with full price (keeps $ + code)
            button.setAttribute('data-price', priceText);
            span.textContent = priceText;

            // Extract prefix and suffix (currency symbol/code)
            let parts = priceText.split(match[0]);
            let prefix = parts[0] || ""; // e.g. "$"
            let suffix = parts[1] || ""; // e.g. " NZD"

            // ---- Update 4x payment text ----
            let installment = (amount / 4).toFixed(2); // divide into 4
            document.querySelectorAll('.text-4x').forEach(el => {
              el.textContent = `4x payments of ${prefix}${installment}${suffix}`;
            });
          }
        }, 50); // 50–100ms is usually enough
      }
    });
  });
});







  
  
  

$(document).on('click', '.luggage-tag', function(e) {
 let tag_button_form = document.querySelector('.tag_button_form');
 let yes_checkbox=tag_button_form.querySelector('#yes1');
 let recipient_input=tag_button_form.querySelector('.recipient-input');
 if(yes_checkbox.checked && recipient_input.value== ''){
   document.querySelector('.embossing-text-error').classList.remove('hidden');
   return
 }
  $(this).find('.btn_text').text('Adding...');
  $(this).find('.btn_price').hide();
    setTimeout(() => {
    $(this).find('.btn_text').text('Added!');
  }, 1000);
  setTimeout(() => {
    $(this).find('.btn_text').text('Add to cart - ');
    $(this).find('.btn_price').show();
  }, 5000);
});
  
$(document).on('click', '.add_to_crt_btn .button', function(e) {
  const $btn = $(this);
  const price = $btn.data('price'); // get data-price attribute
  const is_preorder = $btn.data('is-preorder'); // get data-price attribute

  console.log("data-is-preorder",is_preorder);

  $btn.text('Adding...');
  
  setTimeout(() => {
    $btn.text('Added!');
  }, 500);

  if(is_preorder){
  const preorder_text = $btn.data('pre-order-text'); // get data-price attribute

    setTimeout(() => {
    $btn.text(preorder_text);
  }, 5000);
  }
  else{
  setTimeout(() => {
    $btn.text(`Add to Cart - ${price}`);
  }, 5000);
  }
});

    async function checkNopenCart() {
    let isCartDrawer = $(".cart__drawer");
    if (isCartDrawer) {
      await fetch("/?section_id=cart-drawer")
        .then((response) => response.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          document.querySelector("cart-quantity").updateHTML(html);
          document.querySelector(".cart-drawer").classList.add("open_drawer");
          document.body.classList.add("overflow-hidden");
        })
        .catch((err) => console.error(err));
    } else {
      return;
    }
  }
  
});


// function addAllItems(array){
// 	Shopify.queue = [];
// 	  var quantity = {{ cart.item_count }} ;
// 	  var newArray = array.split(',');
// 	  for (var i = 0; i < newArray.length; i++) {
// 	    product = newArray[i]
// 	    Shopify.queue.push({
// 	      variantId: product,
// 	    });
//           }
// 	  Shopify.moveAlong = function() {
// 	  // If we still have requests in the queue, let's process the next one.
// 	  if (Shopify.queue.length) {
// 	    var request = Shopify.queue.shift();
// 	    var data = 'id='+ request.variantId + '&quantity=1'
// 	    $.ajax({
// 	      type: 'POST',
//               url: '/cart/add.js',
// 	      dataType: 'json',
// 	      data: data,
// 	      success: function(res){
// 	        Shopify.moveAlong();
// 		  quantity += 1;
// 	     },
//              error: function(){
// 	     // if it's not last one Move Along else update the cart number with the current quantity
// 		  if (Shopify.queue.length){
// 		    Shopify.moveAlong()
// 		  } else {
// 		    $('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
// 		  }
// 	      }
//            });
//         }
// 	 // If the queue is empty, we add 1 to cart
// 	else {
// 	  quantity += 1;
// 	  addToCartOk(quantity);
// 	 }
//        };
//     Shopify.moveAlong();
//   };



 $(document).ready(function(e){

/*
infiniteslide.js v2
version: 2.0.1
Author: T.Morimoto

Copyright 2017, T.Morimoto
* Free to use and abuse under the MIT license.
* http://www.opensource.org/licenses/mit-license.php

https://github.com/woodroots/infiniteslidev2
*/

(function($){
	$(function(){
		$.fn.infiniteslide = function(options){
			//option
			var settings = $.extend({
				'speed': 100, //é€Ÿã•ã€€å˜ä½ã¯px/ç§’ã§ã™ã€‚
				'direction': 'left', //up/down/left/rightã‹ã‚‰é¸æŠž
				'pauseonhover': true, //ãƒžã‚¦ã‚¹ã‚ªãƒ¼ãƒãƒ¼ã§ã‚¹ãƒˆãƒƒãƒ—
				'responsive': false, //å­è¦ç´ ã®å¹…ã‚’%ã§æŒ‡å®šã—ã¦ã„ã‚‹ã¨ã
				'clone': 1
			},options);
			
			var setCss = function(obj,direction){
				$(obj).wrap('<div class="infiniteslide_wrap"></div>').parent().css({
					overflow: 'hidden'
				});

				if(direction == 'up' || direction == 'down'){
					var d = 'column';
				} else {
					var d = 'row';
				}
								
				$(obj).css({
					display: 'flex',
					flexWrap: 'nowrap',
					alignItems: 'center',
					'-ms-flex-align': 'center',
					flexDirection: d
				}).children().css({
						flex: 'none',
						display: 'block'
					});
			}
			
			var setClone = function(obj,clone){
				var $clone = $(obj).children().clone().addClass('infiniteslide_clone');
				i = 1;
				while(i <= clone){
					$clone.clone().appendTo($(obj));
					i++;
				}
			}
			
			var getWidth = function(obj){
				w = 0;
				$(obj).children(':not(.infiniteslide_clone)').each(function(key,value){
					w = w + $(this).outerWidth(true);
				});
				return w;
			}
			var getHeight = function(obj){
				h = 0;
				$(obj).children(':not(.infiniteslide_clone)').each(function(key,value){
					h = h + $(this).outerHeight(true);
				});
				return h;
			}

			
			var getSpeed = function(l,s){
				return l / s;
			}
			var getNum = function(obj,direction){
				if(direction == 'up' || direction == 'down'){
					var num = getHeight(obj);
				} else {
					var num = getWidth(obj);
				}
				return num;
			}
			
			var getTranslate = function(num,direction){
				if(direction == 'up' || direction == 'down'){
					var i = '0,-' + num + 'px,0';
				} else {
					var i = '-' + num + 'px,0,0';
				}
				return i;
			}
			
			var setAnim = function(obj,id,direction,speed){
				var num = getNum(obj,direction);
				if(direction == 'up' || direction == 'down'){
					$(obj).parent('.infiniteslide_wrap').css({
						height: num + 'px'
					});
				}
				var i = getTranslate(num,direction);
				
				$(obj).attr('data-style','infiniteslide' + id);

				var css = '@keyframes infiniteslide' + id + '{' + 
								'from {transform:translate3d(0,0,0);}' + 
								'to {transform:translate3d(' + i + ');}' + 
							'}';
				$('<style />').attr('id','infiniteslide' + id + '_style')
				.html(css)
				.appendTo('head');
				
				if(direction == 'right' || direction == 'down'){
					var reverse = ' reverse';
				} else {
					var reverse = '';
				}
				
				$(obj).css({
					animation: 'infiniteslide' + id + ' ' + getSpeed(num,speed) + 's linear 0s infinite' + reverse
				});
			}
			var setStop = function(obj){
				$(obj).on('mouseenter',function(){
					$(this).css({
						animationPlayState: 'paused'
					});
				}).on('mouseleave',function(){
					$(this).css({
						animationPlayState: 'running'
					});
				});
			}
			
			var setResponsive = function(obj,direction){
					var num = getNum(obj,direction);
					var i = getTranslate(num,direction);
					return i;
				};
			
			return this.each(function(key,value){
				var $this = $(this);
				var num = Date.now() + Math.floor(10000*Math.random()).toString(16);
				if(settings.pauseonhover == true){
					setStop($this);
				}
				$(window).on('load',function(){
					setCss($this,settings.direction);
					setClone($this,settings.clone);
					setAnim($this,num,settings.direction,settings.speed);
					
					if(settings.responsive){
						$(window).on('resize',function(){
							var i = setResponsive($this,settings.direction);
							var styleid = $this.attr('data-style');
							var stylehtml = $('#' + styleid + '_style').html();
							var stylehtml_new = stylehtml.replace(/to {transform:translate3d\((.*?)\)/,'to {transform:translate3d(' + i + ')');
							$('#' + styleid + '_style').html(stylehtml_new);

						});
					}
				});
			});
			
		}
	});
})(jQuery);
    $(function(){
        $('.infiniteslide').infiniteslide({
            'speed': 100, //speed this is px/min
            'direction': 'left', //choose  up/down/left/right
            'pauseonhover': true, //if true,stop onmouseover
            'responsive': false, //width/height recalculation on window resize. child element's width/height define %/vw/vh,this set true.
            'clone': 2 //if child elements are too few (elements can't "infinite"), set 2 or over.
        });
    });
  })


$(document).ready(function () {
  setTimeout(function () {
    var $reviews = $('#judgeme_product_reviews');

    if ($reviews.find('.jdgm-rev-widg__body .jdgm-rev').length === 0) {
      $('body').addClass('no-review');
    }
  }, 2000); // 1000 ms = 1 second
});


document.querySelectorAll('.embossing_3letter_2digits').forEach(input => {
  input.addEventListener('input', function() {
    let value = this.value.replace(/[^a-zA-Z0-9]/g, ''); // only letters + digits
    let letters = value.replace(/[^a-zA-Z]/g, '').split('');
    let digits = value.replace(/[^0-9]/g, '').split('');

    let newValue = '';
    let letterCount = 0;
    let digitCount = 0;

    for (let char of value) {
      if (/[a-zA-Z]/.test(char)) {
        if (letterCount < 3) {
          newValue += char;
          letterCount++;
        }
      } else if (/[0-9]/.test(char)) {
        if (digitCount < 2) {
          newValue += char;
          digitCount++;
        }
      }
      if (newValue.length >= 5) break; // stop at max length
    }

    this.value = newValue;
  });
});
